module.exports = __webpack_public_path__ + "img/img9.52b4ced2.svg";